import { IAlert } from "../../../models/alert.model";
import { ISelectedAlerts, IAlerts } from "../alert.states";
import { IAlertFilter } from "../../../../modules/alerts/filter";
import { alertMatchesCurrentFilter } from "./filter.helpers";

export function validateSelectedAlert(
    previousSelectedAlerts: ISelectedAlerts,
    newFilteredTotal: number,
    changedAlertId: string,
    oldMatchesFilterForChangedAlert: boolean,
    newMatchesFilterForChangedAlert: boolean
): ISelectedAlerts {
    let newSelectedAlertsState: ISelectedAlerts = {
        ...previousSelectedAlerts,
        selected: new Set(previousSelectedAlerts.selected),
        deselected: new Set(previousSelectedAlerts.deselected),
    };

    const filterMatchLost: boolean = oldMatchesFilterForChangedAlert && !newMatchesFilterForChangedAlert;
    const filterMatchGained: boolean = !oldMatchesFilterForChangedAlert && newMatchesFilterForChangedAlert;

    if (filterMatchLost) {
        if (newSelectedAlertsState.allSelected) {
            newSelectedAlertsState.deselected.add(changedAlertId);
        } else if (newSelectedAlertsState.selected.has(changedAlertId)) {
            newSelectedAlertsState.selected.delete(changedAlertId);
        }
    } else if (filterMatchGained) {
        if (newSelectedAlertsState.allSelected) {
            if (newSelectedAlertsState.deselected.has(changedAlertId)) {
                newSelectedAlertsState.deselected.delete(changedAlertId);
            }
        }
    }

    if (newSelectedAlertsState.allSelected) {
        newSelectedAlertsState.currentCount = newFilteredTotal;
    } else {
        newSelectedAlertsState.currentCount = newSelectedAlertsState.selected.size;
    }

    return newSelectedAlertsState;
}


export function validateSelectedAlerts(
    originalAlertsState: IAlerts,
    originalSelectedAlerts: ISelectedAlerts,
    currentFilter: IAlertFilter,
    newFilteredTotal: number,
    processedAlertsInfo: Array<{
        id: string;
        alertDataAfterProcessing: IAlert;
    }>
): ISelectedAlerts {
    let updatedSelectedAlerts: ISelectedAlerts = originalSelectedAlerts;

    for (const { id: processedAlertId, alertDataAfterProcessing } of processedAlertsInfo) {
        const originalAlertData = originalAlertsState.items.find(a => a.id === processedAlertId);
        if (!originalAlertData) continue;

        const oldMatchesFilter = alertMatchesCurrentFilter(originalAlertData, currentFilter);
        const newMatchesFilter = alertMatchesCurrentFilter(alertDataAfterProcessing, currentFilter);

        updatedSelectedAlerts = validateSelectedAlert(
            updatedSelectedAlerts,
            newFilteredTotal,
            processedAlertId,
            oldMatchesFilter,
            newMatchesFilter
        );
    }
    return updatedSelectedAlerts;
}
